<template>
  <div class="developers-box2 flex-column">
    <Header1></Header1>
    <div class="developers-header flex-row">
      <div style="font-size: 20px">
        {{ appInfo && appInfo.id ? "编辑应用" : "创建应用" }}
      </div>
    </div>
    <div class="developers-main">
      <el-form
        style="margin-top: 20px"
        ref="form"
        :model="form"
        :rules="rules"
        label-width="90px"
      >
        <!-- <el-form-item label="应用分类" prop="appType">
          <el-select v-model="form.appType" placeholder="请选择应用分类">
            <el-option label="电商类(读写)" value="0" />
            <el-option label="快递物流类(只读)" value="1" />
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="应用code" prop="appCode">
          <el-input v-model="form.appCode" placeholder="请输入应用code" />
        </el-form-item> -->
        <el-form-item label="应用名称" prop="appName">
          <el-input v-model="form.appName" placeholder="请输入应用名称" />
        </el-form-item>
        <el-form-item label="应用logo">
          <!-- <image-upload v-model="form.logo" /> -->
          <el-upload
            :action="uploadImgUrl"
            list-type="picture-card"
            :file-list="fileList"
            :on-success="imgSuccess"
            :on-change="changePic"
          >
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{ file }">
              <img
                class="el-upload-list__item-thumbnail"
                :src="file.url"
                alt=""
              />
              <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-preview"
                  @click="handlePictureCardPreview(file)"
                >
                  <i class="el-icon-zoom-in"></i>
                </span>

                <span
                  class="el-upload-list__item-delete"
                  @click="handleRemove(file)"
                >
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="应用说明" prop="info">
          <el-input
            v-model="form.info"
            type="textarea"
            placeholder="请输入内容"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <!-- <el-button @click="cancel">取 消</el-button> -->
      </div>
    </div>

    <!-- 图片放大 -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import Header1 from "@/components/Header1.vue";
import { instapplication, updateApplication, editApp } from "@/api/developers";

export default {
  components: {
    Header1,
  },
  data() {
    return {
      uploadImgUrl: "https://server.wuxianliuliang.cn/api/file/img/upload", // 上传的图片服务器地址
      pageSize: 2,
      total: 10,
      currentPage: 1,
      currentFile: "",
      // 表单参数
      form: {
        appName: "",
        logo: "",
        info: "",
      },
      imageUrl: "",
      // 表单校验
      rules: {
        // appType: [
        //   { required: true, message: "应用分类不能为空", trigger: "blur" },
        // ],
        // appCode: [
        //   { required: true, message: "应用code不能为空", trigger: "blur" },
        // ],
        appName: [
          { required: true, message: "应用名称不能为空", trigger: "blur" },
        ],
      },
      // 上传组件
      dialogImageUrl: "",
      dialogVisible: false,
      fileList: [],
      appInfo: {},
    };
  },
  mounted() {
    if (window.localStorage.getItem("appDetail")) {
      let detail = JSON.parse(window.localStorage.getItem("appDetail"));
      this.appInfo = detail;

      if (detail) {
        this.form.appName = detail.name;
        this.form.info = detail.applicationDesc;
        this.form.appid = detail.appid;
        this.form.id = detail.id;
        this.imageUrl = detail.applicationLogo;
        this.fileList = [
          {
            url: detail.applicationLogo,
          },
        ];
      }
    }
  },
  methods: {
    changePic(file, fileList) {
      this.fileList = fileList.slice(-1);
      this.currentFile = file;
    },
    imgSuccess(res, file, fileList) {
      this.imageUrl = res.data;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemove(file) {
      console.log(file);
    },
    currentChange() {},
    appDetail() {
      this.$router.push("/appDetail");
    },
    submitForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let data = {
            name: this.form.appName,
            appId: "",
            applicationDesc: this.form.info,
            applicationLogo: this.imageUrl,
          };
          if (this.appInfo && this.appInfo.id) {
            data.appId = this.appInfo.appId;
          }
          // 新增
          editApp(data).then((res) => {
            if (res.code == 200) {
              this.$message.success(res.message);

              this.form = {
                appName: "",
                info: "",
              };
              this.imageUrl = "";
              this.fileList = [];
              this.$router.push("/developers");
            }
          });
        }
      });
    },

    getList() {
      getAppList().then((res) => {
        console.log("------>", res);
      });
    },
  },

  beforeDestroy() {
    window.localStorage.setItem("appDetail", "");
  },
};
</script>

<style scoped lang="scss">
.developers-box2 {
  padding: 80px 40px 0;

  .developers-main {
    width: 500px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    margin-top: 20px;

    .box-card {
      position: relative;
      .delete-btn {
        position: absolute;
        top: 20px;
        right: 20px;
        font-size: 20px;
        cursor: pointer;
      }
      .edit-btn {
        position: absolute;
        bottom: 20px;
        right: 20px;
        cursor: pointer;
      }
    }
    .card-item {
      margin-bottom: 15px;
    }
  }
  .developers-header {
    height: 10%;
    max-height: 60px;
    position: relative;

    .add-btn {
      position: absolute;
      right: 0;
      bottom: 15px;
      cursor: pointer;
      padding: 10px 14px;
    }
  }
}
</style>
